var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigbusiness5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6781)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 119.593,
    x2: 17.9658,
    y2: -21.9222,
    stroke: "url(#paint0_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 119.593,
    x2: 52.9658,
    y2: -21.9222,
    stroke: "url(#paint1_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 119.593,
    x2: 88.9658,
    y2: -21.9222,
    stroke: "url(#paint2_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 119.593,
    x2: 124.966,
    y2: -21.9222,
    stroke: "url(#paint3_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 119.593,
    x2: 160.966,
    y2: -21.9222,
    stroke: "url(#paint4_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 119.593,
    x2: 195.966,
    y2: -21.9222,
    stroke: "url(#paint5_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 119.593,
    x2: 231.966,
    y2: -21.9223,
    stroke: "url(#paint6_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.4539,
    x2: 258.387,
    y2: 18.4538,
    stroke: "url(#paint7_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.4539,
    x2: 258.387,
    y2: 77.4538,
    stroke: "url(#paint8_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.4539,
    x2: 258.387,
    y2: 47.4538,
    stroke: "url(#paint9_linear_75_6781)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5978 43.7765C51.229 43.304 54.9303 43.0625 58.6875 43.0625C62.4447 43.0625 66.146 43.3057 69.7773 43.7765C73.1407 44.214 75.5365 47.0333 75.736 50.2988C75.1509 50.1038 74.5446 49.9799 73.93 49.9295C69.0268 49.5225 64.0982 49.5225 59.195 49.9295C55.0685 50.2725 52.125 53.762 52.125 57.689V65.1895C52.1234 66.6311 52.5201 68.0451 53.2715 69.2755C54.0228 70.5058 55.0995 71.5046 56.3827 72.1615L51.74 76.8025C51.5564 76.9858 51.3227 77.1106 51.0682 77.1612C50.8138 77.2117 50.5501 77.1857 50.3104 77.0865C50.0707 76.9873 49.8658 76.8192 49.7216 76.6036C49.5773 76.388 49.5002 76.1344 49.5 75.875V68.8225C48.8651 68.755 48.231 68.6803 47.5978 68.5985C44.0838 68.14 41.625 65.0828 41.625 61.6335V50.7415C41.625 47.294 44.0838 44.235 47.5978 43.7782V43.7765Z",
    fill: "#A4D143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5625 52.25C64.1545 52.25 61.7692 52.3498 59.412 52.5458C56.717 52.7698 54.75 55.0553 54.75 57.6908V65.1895C54.75 67.8268 56.724 70.114 59.4225 70.3345C61.5978 70.513 63.7975 70.6093 66.0165 70.6233L70.885 75.49C71.0686 75.6733 71.3023 75.7981 71.5568 75.8487C71.8112 75.8992 72.0749 75.8733 72.3146 75.774C72.5543 75.6748 72.7592 75.5067 72.9034 75.2911C73.0477 75.0755 73.1248 74.8219 73.125 74.5625V70.38L73.7025 70.3345C76.401 70.1158 78.375 67.8268 78.375 65.1895V57.689C78.375 55.0553 76.4062 52.7698 73.713 52.544C71.3346 52.3473 68.949 52.2492 66.5625 52.25Z",
    fill: "#83A735"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 16.625,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6781)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 158.125V153.616H24.4381C27.7642 153.616 30.0411 151.696 30.0411 148.392C30.0411 145.066 27.7642 143.169 24.4381 143.169H17.1161V158.125H19.527ZM24.2148 145.334C26.4695 145.334 27.6303 146.182 27.6303 148.392C27.6303 150.602 26.4695 151.45 24.2148 151.45H19.527V145.334H24.2148ZM33.8931 158.125V151.897C33.8931 149.91 34.6744 148.861 36.5718 148.861C38.2237 148.861 38.8934 149.598 38.8934 151.183V152.165H41.282V150.714C41.282 148.615 40.1881 146.807 37.6656 146.807C35.3887 146.807 34.1833 148.236 33.8484 150.022H33.6922V147.03H31.4822V158.125H33.8931ZM48.4663 158.348C52.1719 158.348 54.6497 156.004 54.6497 152.589C54.6497 149.129 52.1719 146.807 48.4663 146.807C44.783 146.807 42.3051 149.129 42.3051 152.589C42.3051 156.004 44.783 158.348 48.4663 158.348ZM48.4663 156.205C45.7875 156.205 44.6714 154.933 44.6714 152.589C44.6714 150.223 45.7875 148.928 48.4663 148.928C51.1674 148.928 52.2835 150.223 52.2835 152.589C52.2835 154.933 51.1674 156.205 48.4663 156.205ZM58.8102 158.125V152.634C58.8102 150.178 59.6361 148.973 62.0247 148.973C64.1677 148.973 65.016 149.91 65.016 152.098V158.125H67.4045V152.634C67.4045 150.178 68.2528 148.973 70.619 148.973C72.762 148.973 73.6326 149.91 73.6326 152.098V158.125H76.0212V151.45C76.0212 148.772 74.5702 146.807 71.6905 146.807C68.8778 146.807 67.6277 148.571 67.3375 150.468H67.2036C66.8911 148.348 65.5294 146.807 63.0069 146.807C60.2388 146.807 59.0334 148.526 58.7432 150.379H58.6093V147.03H56.3993V158.125H58.8102ZM80.5881 161.92V155H80.6774C81.1239 157.031 82.7311 158.348 85.2313 158.348C88.6914 158.348 90.5888 156.027 90.5888 152.589C90.5888 149.151 88.6467 146.807 85.209 146.807C82.5972 146.807 81.0346 148.057 80.5881 150.111H80.3872V147.03H78.1773V161.92H80.5881ZM80.5881 152.767V152.567C80.5881 150.178 81.9722 149.017 84.45 149.017C86.7716 149.017 88.1779 149.91 88.1779 152.589C88.1779 155.245 86.7939 156.161 84.4054 156.161C82.0391 156.161 80.5881 155.044 80.5881 152.767ZM99.5372 158.125V155.96H97.5281C96.1441 155.96 95.519 155.603 95.519 154.241V149.04H99.5372V147.03H95.519V144.597H93.1305V147.03H91.2554V149.04H93.1305V154.375C93.1305 157.076 94.6038 158.125 96.9924 158.125H99.5372ZM108.119 158.348C110.642 158.348 112.405 157.232 112.986 155.357H113.142V158.125H115.352V151.383C115.352 148.727 113.767 146.807 110.24 146.807C106.713 146.807 104.615 148.705 104.615 151.227V151.317H107.003V151.227C107.003 149.598 108.008 148.928 110.061 148.928C112.182 148.928 112.986 149.575 112.986 151.406V152.053L107.941 152.589C105.753 152.834 104.369 153.727 104.369 155.446C104.369 157.277 105.82 158.348 108.119 158.348ZM106.78 155.29C106.78 154.419 107.383 154.129 108.633 153.973L112.986 153.482C112.986 155.669 111.289 156.607 108.767 156.607C107.383 156.607 106.78 156.183 106.78 155.29ZM119.915 158.125V152.634C119.915 150.223 121.009 148.973 123.442 148.973C125.741 148.973 126.679 150.022 126.679 152.098V158.125H129.09V151.45C129.09 148.883 127.572 146.807 124.491 146.807C121.678 146.807 120.205 148.593 119.87 150.468H119.714V147.03H117.504V158.125H119.915ZM136.127 158.348C138.627 158.348 140.256 157.143 140.725 154.933H140.881V158.125H143.091V143.169H140.68V150.044H140.547C140.1 148.169 138.604 146.807 135.97 146.807C132.6 146.807 130.68 149.129 130.68 152.589C130.68 156.004 132.622 158.348 136.127 158.348ZM133.113 152.589C133.113 149.91 134.497 148.995 136.819 148.995C139.296 148.995 140.68 150.156 140.68 152.522V152.701C140.68 155.022 139.229 156.138 136.863 156.138C134.475 156.138 133.113 155.245 133.113 152.589ZM22.6969 185.348C26.0007 185.348 28.3223 183.719 28.3223 181.352V181.152H25.9114V181.33C25.9114 182.647 24.9515 183.406 22.6299 183.406C20.0628 183.406 19.0136 182.268 18.9243 180.125H28.3446C28.4116 179.79 28.4339 179.477 28.4339 179.075C28.4339 175.705 26.09 173.807 22.6522 173.807C19.0359 173.807 16.6697 176.129 16.6697 179.589C16.6697 183.295 19.0582 185.348 22.6969 185.348ZM22.6076 175.705C24.9738 175.705 26.1569 176.687 26.1569 178.741V178.785H18.9466C19.0806 176.799 20.1521 175.705 22.6076 175.705ZM33.4987 185.125V176.04H37.4722V174.03H33.4541C33.3202 172.423 34.2354 171.954 35.9989 171.954H37.4722V170.169H36.3784C33.2309 170.169 31.3781 171.597 31.1102 174.03H29.4136V176.04H31.0879V185.125H33.4987ZM41.6913 185.125V176.04H45.6648V174.03H41.6466C41.535 172.423 42.4279 171.954 44.1914 171.954H45.6648V170.169H44.5709C41.4234 170.169 39.5929 171.597 39.325 174.03H37.6062V176.04H39.3027V185.125H41.6913ZM49.415 172.736V170.169H47.0265V172.736H49.415ZM49.415 185.125V174.03H47.0265V185.125H49.415ZM57.2718 185.348C60.5979 185.348 63.0311 183.473 63.0311 180.705V180.46H60.6426V180.616C60.6426 182.335 59.3925 183.183 57.2272 183.183C54.727 183.183 53.6109 181.977 53.6109 179.589C53.6109 177.156 54.727 175.973 57.2272 175.973C59.3925 175.973 60.6426 176.821 60.6426 178.54V178.674H63.0311V178.45C63.0311 175.682 60.5979 173.807 57.2718 173.807C53.6109 173.807 51.2223 176.129 51.2223 179.589C51.2223 183.004 53.6109 185.348 57.2718 185.348ZM67.2249 172.736V170.169H64.814V172.736H67.2249ZM67.2249 185.125V174.03H64.814V185.125H67.2249ZM75.0381 185.348C78.3419 185.348 80.6635 183.719 80.6635 181.352V181.152H78.2526V181.33C78.2526 182.647 77.2927 183.406 74.9711 183.406C72.404 183.406 71.3548 182.268 71.2655 180.125H80.6858C80.7528 179.79 80.7751 179.477 80.7751 179.075C80.7751 175.705 78.4312 173.807 74.9934 173.807C71.3771 173.807 69.0109 176.129 69.0109 179.589C69.0109 183.295 71.3994 185.348 75.0381 185.348ZM74.9488 175.705C77.315 175.705 78.4981 176.687 78.4981 178.741V178.785H71.2878C71.4218 176.799 72.4933 175.705 74.9488 175.705ZM84.9917 185.125V179.634C84.9917 177.223 86.0855 175.973 88.5187 175.973C90.818 175.973 91.7555 177.022 91.7555 179.098V185.125H94.1664V178.45C94.1664 175.883 92.6485 173.807 89.5679 173.807C86.7552 173.807 85.2819 175.593 84.947 177.468H84.7908V174.03H82.5808V185.125H84.9917ZM103.592 185.125V182.96H101.583C100.199 182.96 99.5738 182.603 99.5738 181.241V176.04H103.592V174.03H99.5738V171.597H97.1852V174.03H95.3101V176.04H97.1852V181.375C97.1852 184.076 98.6586 185.125 101.047 185.125H103.592ZM114.518 185.348C117.844 185.348 120.277 183.473 120.277 180.705V180.46H117.889V180.616C117.889 182.335 116.639 183.183 114.473 183.183C111.973 183.183 110.857 181.977 110.857 179.589C110.857 177.156 111.973 175.973 114.473 175.973C116.639 175.973 117.889 176.821 117.889 178.54V178.674H120.277V178.45C120.277 175.682 117.844 173.807 114.518 173.807C110.857 173.807 108.468 176.129 108.468 179.589C108.468 183.004 110.857 185.348 114.518 185.348ZM126.681 185.348C129.538 185.348 131.012 183.562 131.369 181.687H131.503V185.125H133.713V174.03H131.324V179.522C131.324 181.933 130.186 183.183 127.73 183.183C125.386 183.183 124.426 182.134 124.426 180.058V174.03H122.038V180.705C122.038 183.272 123.556 185.348 126.681 185.348ZM141.149 185.348C144.274 185.348 146.328 184.12 146.328 182.044C146.328 180.214 145.122 179.321 142.488 178.986L139.921 178.629C138.247 178.406 137.8 178.093 137.8 177.223C137.8 176.173 138.515 175.727 140.546 175.727C143.002 175.727 143.671 176.419 143.671 177.736V177.87H146.06V177.803C146.06 175.169 144.006 173.807 140.613 173.807C137.198 173.807 135.434 175.191 135.434 177.133C135.434 178.986 136.707 179.879 138.805 180.147L141.841 180.549C143.426 180.772 143.962 181.062 143.962 181.977C143.962 182.96 143.314 183.406 141.149 183.406C138.827 183.406 137.957 182.937 137.957 181.486V181.308H135.546V181.375C135.546 183.942 137.577 185.348 141.149 185.348ZM155.345 185.125V182.96H153.335C151.951 182.96 151.326 182.603 151.326 181.241V176.04H155.345V174.03H151.326V171.597H148.938V174.03H147.063V176.04H148.938V181.375C148.938 184.076 150.411 185.125 152.8 185.125H155.345ZM162.523 185.348C166.228 185.348 168.706 183.004 168.706 179.589C168.706 176.129 166.228 173.807 162.523 173.807C158.839 173.807 156.361 176.129 156.361 179.589C156.361 183.004 158.839 185.348 162.523 185.348ZM162.523 183.205C159.844 183.205 158.728 181.933 158.728 179.589C158.728 177.223 159.844 175.928 162.523 175.928C165.224 175.928 166.34 177.223 166.34 179.589C166.34 181.933 165.224 183.205 162.523 183.205ZM172.866 185.125V179.634C172.866 177.178 173.692 175.973 176.081 175.973C178.224 175.973 179.072 176.91 179.072 179.098V185.125H181.461V179.634C181.461 177.178 182.309 175.973 184.675 175.973C186.818 175.973 187.689 176.91 187.689 179.098V185.125H190.077V178.45C190.077 175.772 188.626 173.807 185.747 173.807C182.934 173.807 181.684 175.571 181.394 177.468H181.26C180.947 175.348 179.586 173.807 177.063 173.807C174.295 173.807 173.09 175.526 172.8 177.379H172.666V174.03H170.456V185.125H172.866ZM197.814 185.348C201.118 185.348 203.44 183.719 203.44 181.352V181.152H201.029V181.33C201.029 182.647 200.069 183.406 197.747 183.406C195.18 183.406 194.131 182.268 194.042 180.125H203.462C203.529 179.79 203.551 179.477 203.551 179.075C203.551 175.705 201.207 173.807 197.77 173.807C194.153 173.807 191.787 176.129 191.787 179.589C191.787 183.295 194.176 185.348 197.814 185.348ZM197.725 175.705C200.091 175.705 201.274 176.687 201.274 178.741V178.785H194.064C194.198 176.799 195.269 175.705 197.725 175.705ZM207.768 185.125V178.897C207.768 176.91 208.549 175.861 210.447 175.861C212.099 175.861 212.768 176.598 212.768 178.183V179.165H215.157V177.714C215.157 175.615 214.063 173.807 211.54 173.807C209.264 173.807 208.058 175.236 207.723 177.022H207.567V174.03H205.357V185.125H207.768ZM22.362 212.348C25.4873 212.348 27.541 211.12 27.541 209.044C27.541 207.214 26.3355 206.321 23.7014 205.986L21.1343 205.629C19.4601 205.406 19.0136 205.093 19.0136 204.223C19.0136 203.173 19.7279 202.727 21.7593 202.727C24.2148 202.727 24.8845 203.419 24.8845 204.736V204.87H27.2731V204.803C27.2731 202.169 25.2194 200.807 21.8263 200.807C18.4109 200.807 16.6474 202.191 16.6474 204.133C16.6474 205.986 17.9198 206.879 20.0181 207.147L23.0541 207.549C24.639 207.772 25.1747 208.062 25.1747 208.977C25.1747 209.96 24.5274 210.406 22.362 210.406C20.0405 210.406 19.1699 209.937 19.1699 208.486V208.308H16.759V208.375C16.759 210.942 18.7904 212.348 22.362 212.348ZM33.9013 212.348C36.7586 212.348 38.2319 210.562 38.5891 208.687H38.723V212.125H40.933V201.03H38.5444V206.522C38.5444 208.933 37.406 210.183 34.9504 210.183C32.6065 210.183 31.6466 209.134 31.6466 207.058V201.03H29.2581V207.705C29.2581 210.272 30.776 212.348 33.9013 212.348ZM45.5341 215.92V209H45.6234C46.0699 211.031 47.6771 212.348 50.1773 212.348C53.6374 212.348 55.5348 210.027 55.5348 206.589C55.5348 203.151 53.5927 200.807 50.155 200.807C47.5432 200.807 45.9806 202.057 45.5341 204.111H45.3332V201.03H43.1233V215.92H45.5341ZM45.5341 206.767V206.567C45.5341 204.178 46.9182 203.017 49.396 203.017C51.7176 203.017 53.1239 203.91 53.1239 206.589C53.1239 209.245 51.7399 210.161 49.3514 210.161C46.9851 210.161 45.5341 209.044 45.5341 206.767ZM59.6168 215.92V209H59.7061C60.1525 211.031 61.7598 212.348 64.2599 212.348C67.72 212.348 69.6175 210.027 69.6175 206.589C69.6175 203.151 67.6754 200.807 64.2376 200.807C61.6258 200.807 60.0632 202.057 59.6168 204.111H59.4159V201.03H57.2059V215.92H59.6168ZM59.6168 206.767V206.567C59.6168 204.178 61.0008 203.017 63.4786 203.017C65.8002 203.017 67.2066 203.91 67.2066 206.589C67.2066 209.245 65.8225 210.161 63.434 210.161C61.0678 210.161 59.6168 209.044 59.6168 206.767ZM76.9586 212.348C80.6642 212.348 83.142 210.004 83.142 206.589C83.142 203.129 80.6642 200.807 76.9586 200.807C73.2753 200.807 70.7974 203.129 70.7974 206.589C70.7974 210.004 73.2753 212.348 76.9586 212.348ZM76.9586 210.205C74.2798 210.205 73.1637 208.933 73.1637 206.589C73.1637 204.223 74.2798 202.928 76.9586 202.928C79.6596 202.928 80.7758 204.223 80.7758 206.589C80.7758 208.933 79.6596 210.205 76.9586 210.205ZM87.3025 212.125V205.897C87.3025 203.91 88.0838 202.861 89.9812 202.861C91.6331 202.861 92.3028 203.598 92.3028 205.183V206.165H94.6914V204.714C94.6914 202.615 93.5975 200.807 91.075 200.807C88.7981 200.807 87.5927 202.236 87.2578 204.022H87.1015V201.03H84.8916V212.125H87.3025ZM103.483 212.125V209.96H101.474C100.09 209.96 99.4648 209.603 99.4648 208.241V203.04H103.483V201.03H99.4648V198.597H97.0762V201.03H95.2011V203.04H97.0762V208.375C97.0762 211.076 98.5496 212.125 100.938 212.125H103.483Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6781",
    x1: 19.4661,
    y1: 182.688,
    x2: 19.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6781",
    x1: 54.4661,
    y1: 182.688,
    x2: 54.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6781",
    x1: 90.4661,
    y1: 182.688,
    x2: 90.4661,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6781",
    x1: 126.466,
    y1: 182.688,
    x2: 126.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6781",
    x1: 162.466,
    y1: 182.688,
    x2: 162.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6781",
    x1: 197.466,
    y1: 182.688,
    x2: 197.466,
    y2: 48.8353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6781",
    x1: 233.466,
    y1: 182.688,
    x2: 233.466,
    y2: 48.8352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFC6D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFC6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6781",
    x1: 269.17,
    y1: 18.9539,
    x2: -9.24119,
    y2: 18.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6781",
    x1: 269.17,
    y1: 77.9539,
    x2: -9.24119,
    y2: 77.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6781",
    x1: 269.17,
    y1: 47.9539,
    x2: -9.24119,
    y2: 47.9541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#E8FDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#E8FDBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6781",
    x1: 60,
    y1: 16.125,
    x2: 62.6601,
    y2: 133.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FEDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508459,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6781",
    x1: 60,
    y1: 16.125,
    x2: 60,
    y2: 104.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFCA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8FDBE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6781"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigbusiness5);
export default __webpack_public_path__ + "static/media/bigbusiness5.ed1fbd0b4ca8b24c92390488b7c6ca69.svg";
export { ForwardRef as ReactComponent };